import { defaultStoreUtils } from '@databases/redux';
import { getDatabaseFieldRequired } from '@databases/utils/database/utils';
import {
  getDateField,
  getGroupField,
  isValidDateField,
  isValidGroupField,
  ViewChangeTypes,
} from '@databases/utils/database/view/view';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { useEffect } from 'react';

import useView from './useView';

const useFieldLoader = ({
  contentId,
  fieldType,
}: {
  contentId: string;
  fieldType: 'group' | 'date';
}) => {
  const { view, setViewChange } = useView();
  const layout = view.settings.layout;

  const getField = fieldType === 'group' ? getGroupField : getDateField;
  const isValidField = fieldType === 'group' ? isValidGroupField : isValidDateField;

  const defaultFieldId = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, {
      contentId,
    });
    let defaultFieldId;
    if (database && !getField(database, layout)) {
      defaultFieldId = database.fields.find((fieldId) =>
        isValidField(getDatabaseFieldRequired(database, fieldId))
      );
    }
    return defaultFieldId;
  });

  useEffect(() => {
    if (defaultFieldId) {
      setViewChange({
        type:
          fieldType === 'group'
            ? ViewChangeTypes.LAYOUT_GROUP_FIELD_ID
            : ViewChangeTypes.LAYOUT_DATE_FIELD_ID,
        value: defaultFieldId,
      });
    }
  }, [defaultFieldId, fieldType, setViewChange]);
};

export default useFieldLoader;
